// extracted by mini-css-extract-plugin
export default {"main":"FiltersPopup_main__L0+9u","inner":"FiltersPopup_inner__HMHhc","flasher":"FiltersPopup_flasher__9sY3S","body":"FiltersPopup_body__ZWE70","filter":"FiltersPopup_filter__dSHtT"};